const CommissionReceipt = { data: [], loading: true };
export const GetComReceiptReportRed = (state = CommissionReceipt, action) => {
  switch (action.type) {
    case "get_allcomreceiptreport":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
